<template>
  <div>
    <FormCreateEdit />
  </div>
</template>
<script>
import { defineComponent } from "vue";
import FormCreateEdit from "../../components/views/banner/SponsorCreateEdit.vue";
export default defineComponent({
  components: {
    FormCreateEdit
  },
  setup() {}
});
</script>
